module.exports = __webpack_public_path__ + "static/media/AFTER-trail-exercises.14a1987c.mp3";